// Barrel for geometry module. See https://angular.io/guide/glossary#barrel
export * from './geometry'
